//Import main components
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import BootstrapVue from 'bootstrap-vue'
import VueMaterial from 'vue-material'
import DatePicker from 'vuejs-datepicker'
import router from './router'
import store from './store'
import moment from 'vue-moment'
import VueCarousel from 'vue-carousel';
import DrawerLayout from 'vue-drawer-layout'
import VueSweetalert2 from 'vue-sweetalert2';
import VueAnalytics from 'vue-analytics'
import InfiniteLoading from 'vue-infinite-loading';
import Vue2Filters from 'vue2-filters';



//Common components
import VHeader from './components/libs/VHeader.vue'
import VFooter from './components/libs/VFooter.vue'
import VRightPanel from './components/libs/VRightPanel.vue'
import VDrawer from './components/libs/VDrawer.vue'
import Utility from './components/libs/utility.js'
import VLoadingSpinner from './components/libs/VLoadingSpinner.vue'
//Import App
import App from './App.vue'

//Import Material Design CSS
import 'vue-material/dist/vue-material.min.css'

import './registerServiceWorker'

//Import flexible notification plugin
import VueFlashMessage from './components/flashmessage'
import VAlertView from "./components/libs/VAlertView";

require('dotenv').config()

//Set $http to axios
Vue.prototype.$http = axios;

const token = localStorage.getItem('token')

//Assign components to Vue
Vue.component('vapp-header', VHeader)
Vue.component('vapp-footer', VFooter)
Vue.component('vapp-right-panel', VRightPanel)
Vue.component('vapp-drawer', VDrawer)
Vue.component('vuejs-datepicker', DatePicker)
Vue.component('vapp-loadingspinner', VLoadingSpinner)
Vue.component('vapp-alertview', VAlertView)


//Make Vue use components
Vue.use(VueAxios, axios)
Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(VueMaterial)
Vue.use(moment)
Vue.use(VueCarousel);
Vue.use(VueFlashMessage);
Vue.use(Utility);
Vue.use(DrawerLayout);
Vue.use(VueSweetalert2);
Vue.use(InfiniteLoading);
Vue.use(Vue2Filters);

const VERSION = "1.1.0";
console.log(VERSION);

// Check if prod
const isProd = process.env.NODE_ENV == 'production'

//Axios request headers
axios.defaults.baseURL = 'https://api.financio.co/v2'

if (!isProd){
    axios.defaults.baseURL = 'https://financio-api.local/v2'
}

axios.defaults.headers.common = {
    'Financio-Api-Key': 'a1cab95df79930fa63947a2bc6f746dd',
}

// Load analytics
const analytic = Vue.use(VueAnalytics, {
    id: 'UA-58159795-4',
    router,
    debug: {
        enabled: !isProd,
        sendHitTask: isProd
    }
})

//If logged in, attach Authorization header to axios requests
if (token) {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

Vue.config.productionTip = false
Vue.router = router

Vue.use(require('@websanova/vue-auth'), {
    auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
    http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
    router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
    loginData: {
        redirect: '/'
    },
    logoutData: {
        makeRequest: true,
        redirect: '/login'
    },
})

//Modify page titles
router.beforeEach((to, from, next) => {
    document.title = 'Financio - ' + to.meta.title
    next()
})


export const EventBus = new Vue();
export default analytic;

Vue.material.locale.dateFormat = 'DD/MM/YYYY';
new Vue({
    router,
    store,
    moment,
    render: h => h(App)
}).$mount('#app')
